module.exports = __webpack_public_path__ + "img/智能洞察的自助分析@2x.1bdc94de.png";